import React from "react";

const JobDetailsDialog = ({ details }) => {
  return (
    <>
      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2777AA" }}>
        Job Title
      </div>
      <div style={{ marginBottom: "12px" }}>{details.title}</div>
      {details?.jobCoreSkill?.name && (
        <>
          <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2777AA" }}>
            Core Skill
          </div>
          <div style={{ marginBottom: "12px" }}>{details.jobCoreSkill.name}</div>
        </>
      )}
      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2777AA" }}>
        Job Description
      </div>
      <div dangerouslySetInnerHTML={{ __html: details.job_description }} />
    </>
  );
};

export default JobDetailsDialog;
